import type { SvgIconComponent } from '@mui/icons-material';
import DashboardIcon from '@mui/icons-material/Dashboard';
import PeopleIcon from '@mui/icons-material/People';
import LeadIcon from '@mui/icons-material/PersonSearch';
import CampaignIcon from '@mui/icons-material/Campaign';
import ForumIcon from '@mui/icons-material/Forum';
import ChatBubbleOutlineIcon from '@mui/icons-material/ChatBubbleOutline';
import QuickreplyOutlinedIcon from '@mui/icons-material/QuickreplyOutlined';
import ReceiptIcon from '@mui/icons-material/Receipt';
import InventoryIcon from '@mui/icons-material/Inventory';
import CategoryIcon from '@mui/icons-material/Category';
import WorkspacesIcon from '@mui/icons-material/Workspaces';
import GroupIcon from '@mui/icons-material/Group';
import BadgeIcon from '@mui/icons-material/Badge';
import AssessmentIcon from '@mui/icons-material/Assessment';
import SettingsIcon from '@mui/icons-material/Settings';
import BusinessIcon from '@mui/icons-material/Business';
import DomainIcon from '@mui/icons-material/Domain';
import AddBusinessIcon from '@mui/icons-material/AddBusiness';
import CalendarIcon from '@mui/icons-material/CalendarMonth';
import MedicalServicesIcon from '@mui/icons-material/MedicalServices';
import ScienceIcon from '@mui/icons-material/Science';
import AssignmentIcon from '@mui/icons-material/Assignment';
import FolderSpecialIcon from '@mui/icons-material/FolderSpecial';
import TrackChangesIcon from '@mui/icons-material/TrackChanges';
import HistoryIcon from '@mui/icons-material/History';
import MoreTimeIcon from '@mui/icons-material/MoreTime';
import SecurityIcon from '@mui/icons-material/Security';
import AutoModeIcon from '@mui/icons-material/AutoMode';
import SmsOutlinedIcon from '@mui/icons-material/SmsOutlined';
import PaidIcon from '@mui/icons-material/Paid';
import type { NavKey, NavMenuItem, RailId } from './types';

export const RAIL_ICONS: Record<RailId, SvgIconComponent> = {
  overview: DashboardIcon,
  patients: PeopleIcon,
  appointments: CalendarIcon,
  leads: LeadIcon,
  marketing: CampaignIcon,
  messaging: ForumIcon,
  internalChat: ChatBubbleOutlineIcon,
  finance: ReceiptIcon,
  warehouse: InventoryIcon,
  catalog: CategoryIcon,
  work: WorkspacesIcon,
  hr: BadgeIcon,
  reports: AssessmentIcon,
  settings: SettingsIcon,
};

const MENU_ICONS: Partial<Record<NavKey, SvgIconComponent>> = {
  dashboard: DashboardIcon,
  patients: PeopleIcon,
  leads: LeadIcon,
  messaging: ForumIcon,
  internalChat: ChatBubbleOutlineIcon,
  messagingCanned: QuickreplyOutlinedIcon,
  appointments: CalendarIcon,
  treatmentPlans: MedicalServicesIcon,
  treatmentSessions: MedicalServicesIcon,
  prescriptions: MedicalServicesIcon,
  labOrders: ScienceIcon,
  labPartners: ScienceIcon,
  labo: ScienceIcon,
  suppliers: InventoryIcon,
  payments: ReceiptIcon,
  incomes: ReceiptIcon,
  expenses: ReceiptIcon,
  cashbook: ReceiptIcon,
  promotions: ReceiptIcon,
  referrers: PeopleIcon,
  referralCommissions: PaidIcon,
  commissions: ReceiptIcon,
  payroll: ReceiptIcon,
  stockIn: InventoryIcon,
  stockOut: InventoryIcon,
  transfers: InventoryIcon,
  stocktakes: InventoryIcon,
  treatmentCatalog: CategoryIcon,
  treatmentUoms: CategoryIcon,
  treatmentJournals: CategoryIcon,
  drugs: MedicalServicesIcon,
  prescriptionTemplates: MedicalServicesIcon,
  appointmentTypes: CalendarIcon,
  customerSources: LeadIcon,
  diagnosisCodes: MedicalServicesIcon,
  incomeCategories: ReceiptIcon,
  expenseCategories: ReceiptIcon,
  paymentMethods: ReceiptIcon,
  commissionRules: ReceiptIcon,
  itemCatalog: InventoryIcon,
  warehouseConfig: InventoryIcon,
  staff: BadgeIcon,
  departments: DomainIcon,
  attendanceHistory: HistoryIcon,
  overtime: MoreTimeIcon,
  overtimeRequests: MoreTimeIcon,
  overtimeTypes: MoreTimeIcon,
  workTimesheet: AssessmentIcon,
  tasks: AssignmentIcon,
  projects: FolderSpecialIcon,
  kpiSheets: TrackChangesIcon,
  kpiMetrics: TrackChangesIcon,
  myKpi: TrackChangesIcon,
  teamSchedule: CalendarIcon,
  timeOff: CalendarIcon,
  shiftTypes: CalendarIcon,
  weeklyTemplates: CalendarIcon,
  assignments: CalendarIcon,
  reports: AssessmentIcon,
  reportRevenue: AssessmentIcon,
  reportPatients: AssessmentIcon,
  reportReferrers: AssessmentIcon,
  reportAppointments: AssessmentIcon,
  reportTreatments: AssessmentIcon,
  leadReports: AssessmentIcon,
  inventoryReports: AssessmentIcon,
  users: GroupIcon,
  permissionGroups: SecurityIcon,
  auditLog: HistoryIcon,
  automation: AutoModeIcon,
  outbound: SmsOutlinedIcon,
  settings: SettingsIcon,
  organizations: BusinessIcon,
  provisionClinic: AddBusinessIcon,
};

export const withMenuIcons = (items: NavMenuItem[]): NavMenuItem[] =>
  items.map((item) => {
    const Icon = MENU_ICONS[item.labelKey];
    return {
      ...item,
      icon: Icon ? <Icon fontSize="small" /> : item.icon,
    };
  });
